import React from 'react';
import PropTypes from 'prop-types';
import Heading from 'components/shared/heading';
import styles from './styles.module.scss';

const PhoneIcon = () => (
  <svg version="1.1" width="800px" height="800px" viewBox="0 0 32 32">
    <g>
      <path
        d="M31.584,25.999c0-0.401-0.157-0.778-0.441-1.062l-6.557-6.539c-0.566-0.566-1.553-0.565-2.119-0.001
		l-2.045,2.041c-0.284,0.283-0.44,0.66-0.44,1.062c0,0.217,0.049,0.425,0.136,0.617c-2.695,1.931-6.947-2.199-6.983-2.235
		c-0.167-0.172-0.815-0.819-0.98-0.978c-0.044-0.044-4.222-4.317-2.221-7.006c0.163,0.059,0.336,0.095,0.514,0.095
		c0.4,0,0.776-0.155,1.059-0.438l2.045-2.039c0.284-0.284,0.441-0.661,0.441-1.062s-0.157-0.778-0.441-1.062L6.995,0.85
		c-0.566-0.562-1.552-0.562-2.118,0L2.831,2.891C2.547,3.174,2.39,3.551,2.39,3.952c0,0.12,0.018,0.236,0.045,0.35
		c-0.927,0.77-3.638,3.493-1.822,7.814c1.136,2.701,3.069,6.43,7.973,11.319c4.903,4.891,8.64,6.819,11.348,7.952
		c1.042,0.437,1.991,0.61,2.844,0.61c2.754,0,4.489-1.815,5.033-2.481c0.075,0.011,0.15,0.022,0.227,0.022
		c0.4,0,0.776-0.155,1.059-0.438l2.045-2.039C31.427,26.777,31.584,26.4,31.584,25.999z M3.537,3.599l2.045-2.04
		c0.094-0.095,0.22-0.146,0.353-0.146s0.259,0.052,0.353,0.146L12.846,8.1c0.095,0.094,0.147,0.22,0.147,0.354
		s-0.052,0.26-0.147,0.354l-2.045,2.039c-0.188,0.19-0.518,0.187-0.707,0.001L3.537,4.307C3.442,4.212,3.39,4.086,3.39,3.952
		S3.442,3.692,3.537,3.599z M20.321,30.466c-2.624-1.099-6.248-2.97-11.028-7.738c-4.78-4.767-6.657-8.382-7.757-10.999
		C0.015,8.11,2.126,5.865,2.969,5.151l6.163,6.148c-2.529,3.349,2.107,8.101,2.322,8.317c0.168,0.162,0.8,0.792,0.97,0.968
		c0.164,0.162,3.156,3.077,6.059,3.077c0.784,0,1.557-0.233,2.271-0.77l6.163,6.146C26.198,29.878,23.946,31.979,20.321,30.466z
		 M30.437,26.354l-2.045,2.04c-0.188,0.188-0.517,0.188-0.706-0.001l-6.557-6.539c-0.095-0.095-0.146-0.221-0.146-0.354
		s0.052-0.26,0.146-0.354l2.046-2.041c0.094-0.094,0.219-0.146,0.353-0.146s0.258,0.052,0.353,0.146l6.557,6.54
		c0.095,0.094,0.147,0.22,0.147,0.354S30.532,26.259,30.437,26.354z"
      />
    </g>
  </svg>
);

const WrenchIcon = () => (
  <svg fill="#000000" height="800px" width="800px" version="1.1" viewBox="0 0 512.001 512.001">
    <g>
      <g>
        <path
          d="M509.09,360.265l-72.693-72.693c-1.867-1.864-4.395-2.912-7.032-2.912h-68.515L277.79,201.6
			c-3.883-3.882-10.179-3.882-14.064,0c-3.883,3.883-3.883,10.179,0,14.064l85.973,85.973c1.867,1.864,4.395,2.912,7.032,2.912
			h68.515l66.868,66.868v42.773c0,2.206-1.468,3.142-2.341,3.504c-0.875,0.365-2.576,0.737-4.134-0.821l-35.835-35.836
			c-9.363-9.362-21.802-14.406-35.054-14.236c-13.238,0.182-25.547,5.583-34.663,15.212c-17.921,18.936-17.239,49.604,1.519,68.361
			l35.266,35.266c1.561,1.559,1.184,3.259,0.823,4.133c-0.363,0.876-1.301,2.343-3.506,2.343h-42.773l-66.868-66.868v-68.515
			c0-2.638-1.047-5.167-2.912-7.032l-27.085-27.085c-3.884-3.882-10.179-3.882-14.064,0c-3.883,3.883-3.883,10.179,0,14.064
			l24.172,24.171v68.515c0,2.638,1.047,5.167,2.912,7.032l72.693,72.693c1.867,1.864,4.395,2.912,7.032,2.912h46.891
			c9.613,0,18.199-5.738,21.88-14.619c3.679-8.879,1.664-19.01-5.133-25.808l-35.267-35.266
			c-11.214-11.214-11.723-29.439-1.138-40.625c5.391-5.695,12.669-8.89,20.491-8.997c7.792-0.066,15.183,2.882,20.717,8.414
			l35.835,35.836c6.798,6.795,16.926,8.81,25.808,5.133c8.881-3.678,14.618-12.267,14.618-21.878v-46.891
			C512.001,364.659,510.954,362.131,509.09,360.265z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M210.365,162.303l25.235,25.236c3.884,3.882,10.179,3.882,14.064,0c3.883-3.883,3.883-10.179,0-14.064l-22.324-22.323
			V82.638c0-2.639-1.047-5.167-2.912-7.033L151.737,2.912c-1.867-1.864-4.395-2.912-7.033-2.912H97.812
			c-9.613,0-18.2,5.737-21.878,14.618c-3.678,8.879-1.664,19.01,5.134,25.81l35.265,35.266
			c11.216,11.214,11.725,29.439,1.136,40.624c-5.391,5.696-12.667,8.89-20.489,8.997c-7.841,0.172-15.185-2.881-20.718-8.413
			L40.426,81.066c-6.798-6.795-16.926-8.808-25.808-5.133C5.737,79.612,0,88.201,0,97.812v46.891c0,2.637,1.047,5.166,2.912,7.031
			l72.693,72.694c1.867,1.864,4.395,2.912,7.033,2.912h68.515l81.21,81.212c1.942,1.941,4.488,2.912,7.032,2.912
			s5.09-0.971,7.032-2.912c3.884-3.883,3.884-10.179,0-14.064l-84.123-84.123c-1.867-1.864-4.395-2.912-7.032-2.912H86.756
			l-66.868-66.868V97.812c0-2.206,1.468-3.141,2.341-3.504s2.576-0.737,4.134,0.821l35.835,35.839
			c9.2,9.199,21.379,14.241,34.364,14.241c0.228,0,0.46-0.003,0.689-0.005c13.239-0.183,25.547-5.585,34.66-15.212
			c17.925-18.935,17.243-49.601-1.517-68.361L95.129,26.366c-1.561-1.561-1.184-3.26-0.822-4.135
			c0.363-0.875,1.299-2.341,3.504-2.341h42.773l66.868,66.868v68.514C207.453,157.909,208.5,160.438,210.365,162.303z"
        />
      </g>
    </g>
  </svg>
);

const LaptopIcon = () => (
  <svg version="1.1" width="800px" height="800px" viewBox="0 0 42 32">
    <g>
      <path
        d="M3.5,26C3.776,26,4,25.776,4,25.5V2c0-0.598,0.402-1,1-1h32c0.57,0,1,0.468,1,1.089V25.5
		c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V2.089C39,0.917,38.122,0,37,0H5C3.841,0,3,0.841,3,2v23.5C3,25.776,3.224,26,3.5,26z
		"
      />
      <path
        d="M6.5,3C6.224,3,6,3.224,6,3.5v22C6,25.776,6.224,26,6.5,26h29c0.276,0,0.5-0.224,0.5-0.5v-22
		C36,3.224,35.776,3,35.5,3H6.5z M35,25H7V4h28V25z"
      />
      <path
        d="M41.5,28h-41C0.224,28,0,28.224,0,28.5v1.175C0,30.873,1.408,32,2.5,32h37c1.145,0,2.5-1.355,2.5-2.5v-1
		C42,28.224,41.776,28,41.5,28z M41,29.5c0,0.589-0.911,1.5-1.5,1.5h-37C1.869,31,1,30.232,1,29.675V29h40V29.5z"
      />
    </g>
  </svg>
);

const PackageIcon = () => (
  <svg version="1.1" width="800px" height="800px" viewBox="0 0 485.32 485.32">
    <g>
      <path d="m480.76,79.05c-0.6-0.2-235-78.3-235-78.3-2.1-1-4.1-1-6.2,0l-231.9,76.3c-5.8,2.4-7.2,7.4-7.2,10.3v313.3c0,5.2 3.1,9.3 7.2,10.3l229,73.2c3.5,1.3 7.3,1.8 12.1,0l228.9-73.2c4.1-2.1 7.2-6.2 7.2-10.3v-313.3c5.68434e-14-3.1-1-6.2-4.1-8.3zm-238.1-56.7l198.9,63.9-75.1,24.1-196-64.5 72.2-23.5zm-10.3,438l-211.3-67v-291.4l211.3,67.6v290.8zm10.3-310.2l-198.9-62.8 93.7-30.6 195.3,64.5-90.1,28.9zm10.3,310.2v-291.6l105.1-33.3v32.3l20.6-8.8v-30l85.5-27v290.4h0.1l-211.3,68z" />
    </g>
  </svg>
);

const StatsSection = ({ title = null, description = null, stats = [] }) => {
  if (!stats || stats.length === 0) {
    return null;
  }

  return (
    <div className={styles.topSection}>
      {title && (
        <Heading className={styles.title} tag="h2" size="xl">
          {title}
        </Heading>
      )}
      {description && (
        <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
      )}
      <div className={styles.textContent}>
        <div className={styles.statsGrid}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statItem}>
              {stat?.icon && (
                <div className={styles.statIcon}>
                  {stat.icon === 'phone' && <PhoneIcon />}
                  {stat.icon === 'wrench' && <WrenchIcon />}
                  {stat.icon === 'laptop' && <LaptopIcon />}
                  {stat.icon === 'package' && <PackageIcon />}
                </div>
              )}
              <div className={styles.statText}>
                <span className={styles.statTitle}>{stat.title}</span>
                <span className={styles.statDescription}>{stat.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


StatsSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ),
};

export default StatsSection;
